import angular from 'angular';

(() => {
  class MedicationPrice {
    constructor($log, $http, Endpoints, CMS_API_URL) {
      'ngInject';

      Object.assign(this, {
        $log,
        $http,
        Endpoints,
        CMS_API_URL
      });
    }

    addMedicationPrice(medication_id, pharmacy_id, price) {
      let payload = {
        medication_id: medication_id,
        pharmacy_id: pharmacy_id,
        price: price
      };
      return this.$http.post(this.CMS_API_URL + `/admin/medication-pharmacy-price`, payload);
    }

    getMedsByService(service) {
      return this.$http.get(this.CMS_API_URL + `/admin/medications/${service}`);
    }

    updatePrice(id, pharmacy_id, price) {
      var payload = {
        pharmacy_id: pharmacy_id,
        price: price
      };
      return this.$http.put(this.CMS_API_URL + `/admin/medication-pharmacy-price/${id}`, payload);
    }

    deleteMedication(id) {
      return this.$http.delete(this.CMS_API_URL + `/admin/medication-pharmacy-price/${id}`);
    }

    audit(audit) {
      return this.$http.post(this.CMS_API_URL + `/admin/medication-pharmacy-price/audit`, audit);
    }

  }

  MedicationPrice.$inject = ["$log", "$http", "Endpoints", "CMS_API_URL"];
  angular.module('pims').service('MedicationPrice', MedicationPrice);
})();